import { helper } from '@ember/component/helper';

export default helper(function and([...args]) {
  let allExists = true;
  args.forEach((item) => {
    if (!item) allExists = false;
  });
  return allExists;
});
